import { t } from 'i18n';

export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

export const defaultLocale = 'en';

export const languages = [
  {
    value: 'EN',
    get label() {
      return t('language.english');
    },
  },
  {
    value: 'DE',
    get label() {
      return t('language.german');
    },
  },
  {
    value: 'ES',
    get label() {
      return t('language.spanish');
    },
  },
  {
    value: 'IT',
    get label() {
      return t('language.italian');
    },
  },
  {
    value: 'PT',
    get label() {
      return t('language.portuguese');
    },
  },
  {
    value: 'RU',
    get label() {
      return t('language.russian');
    },
  },
  {
    value: 'JA',
    get label() {
      return t('language.japanese');
    },
  },
  {
    // User language values are sent directly to the backend, whose enum uses CN.
    value: 'CN',
    get label() {
      return t('language.chinese');
    },
  },
  {
    value: 'PL',
    get label() {
      return t('language.polish');
    },
  },
  {
    value: 'CS',
    get label() {
      return t('language.czech');
    },
  },
  {
    value: 'EL',
    get label() {
      return t('language.greek');
    },
  },
  {
    value: 'DA',
    get label() {
      return t('language.danish');
    },
  },
];

export const activeFilterOptions = [
  {
    get label() {
      return t('filters.allUsers');
    },
    value: '',
  },
  {
    get label() {
      return t('filters.activeUsers');
    },
    value: 'active',
  },
  {
    get label() {
      return t('filters.inactiveUsers');
    },
    value: 'inactive',
  },
];

export const activeFilterOptionsAdmin = [
  {
    get label() {
      return t('filters.allAdmins');
    },
    value: '',
  },
  {
    get label() {
      return t('filters.activeAdmins');
    },
    value: 'active',
  },
  {
    get label() {
      return t('filters.inactiveAdmins');
    },
    value: 'inactive',
  },
];

export const activeFilterOptionsOrgs = [
  {
    get label() {
      return t('filters.allOrganizations');
    },
    value: '',
  },
  {
    get label() {
      return t('filters.activeOrganizations');
    },
    value: 'active',
  },
  {
    get label() {
      return t('filters.inactiveOrganizations');
    },
    value: 'inactive',
  },
];

export const programNameMap = {
  1: 'Power',
  2: 'Advanced',
  3: 'Endurance',
  4: 'Metabolism',
  5: 'Fatburning',
  6: 'Relax',
  7: 'Warmup',
};

export const levelNameMap = {
  35: 'Body Toning',
  36: 'Anti Cellulite',
  37: 'Hybrid',
};

export const ORGANIZATION_TYPES = [
  {
    value: 'EMS',
    get label() {
      return t('organizationTypes.ems');
    },
  },
  {
    value: 'DISTRIBUTOR',
    get label() {
      return t('organizationTypes.distributor');
    },
  },
  {
    value: 'CHAIN',
    get label() {
      return t('organizationTypes.chain');
    },
  },
  {
    value: 'GYM',
    get label() {
      return t('organizationTypes.studio');
    },
  },
];

export const ORGANIZATION_TYPES_OPTIONS = [
  {
    value: 'DISTRIBUTOR',
    get label() {
      return t('organizationTypes.distributor');
    },
  },
  {
    value: 'CHAIN',
    get label() {
      return t('organizationTypes.chain');
    },
  },
  {
    value: 'GYM',
    get label() {
      return t('organizationTypes.studio');
    },
  },
];

export const LICENSE_USAGE = [
  {
    value: 'home',
    get label() {
      return t('license.home');
    },
  },
  {
    value: 'studio',
    get label() {
      return t('license.studio');
    },
  },
];

export const LICENSE_TEMPLATE_TYPES = [
  {
    value: 'isPermanent',
    get label() {
      return t('license.permanent');
    },
  },
  // { value: 'isCredit', label: 'Is Credit based' },
  {
    value: 'isPayPerUse',
    get label() {
      return t('license.payPerUse');
    },
  },
  {
    value: 'isTimeBased',
    get label() {
      return t('license.timeBased');
    },
  },
];

export const isPayPerUse = 'isPayPerUse';
export const isCredit = 'isCredit';
export const isPermanent = 'isPermanent';
export const isPool = 'isPool';
export const isTimeBased = 'isTimeBased';

export const USER_ROLES = [
  {
    value: 'STUDIO_USER',
    get label() {
      return t('roles.studioUser');
    },
  },
  {
    value: 'USER',
    get label() {
      return t('roles.studioUser');
    },
  },
  {
    value: 'HOME_USER',
    get label() {
      return t('roles.homeUser');
    },
  },
];

//used for admin filter - be careful with order, this order displays the hierarchy!
export const MEMBER_ROLES = [
  {
    value: 'ADMIN',
    get label() {
      return t('roles.emsAdmin');
    },
  },
  {
    value: 'EMS_ADMIN',
    get label() {
      return t('roles.emsAdmin');
    },
  },
  {
    value: 'GROUP_MANAGER',
    get label() {
      return t('roles.distributor');
    },
  },
  {
    value: 'DISTRIBUTOR',
    get label() {
      return t('roles.distributor');
    },
  },
  {
    value: 'CHAIN_MANAGER',
    get label() {
      return t('roles.chainAdmin');
    },
  },
  {
    value: 'CHAIN_ADMIN',
    get label() {
      return t('roles.chainAdmin');
    },
  },
  {
    value: 'GROUP_ADMIN',
    get label() {
      return t('roles.studioAdmin');
    },
  },
  {
    value: 'STUDIO_ADMIN',
    get label() {
      return t('roles.studioAdmin');
    },
  },
];

export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
